var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "u-col", attrs: { id: "dashboard" } },
    [
      _c("layout-nav"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "u-row u-stretch u-flex" },
        [
          _c(
            "div",
            { staticClass: "view u-flex" },
            [
              _c(
                "ui-map",
                {
                  ref: "map",
                  staticClass: "map",
                  attrs: {
                    view: _vm.query,
                    options: _vm.mapOptions,
                    "heat-points": _vm.heatPoints
                  },
                  on: {
                    idle: _vm.mapped,
                    zoom: _vm.deselect,
                    click: _vm.deselect
                  }
                },
                [
                  _vm._l(_vm.stations, function(station) {
                    return _c("marker-station", {
                      directives: [
                        {
                          name: "coords",
                          rawName: "v-coords",
                          value: station,
                          expression: "station"
                        }
                      ],
                      key: station.id,
                      attrs: { station: station },
                      nativeOn: {
                        click: function($event) {
                          return _vm.zoomTo(station)
                        }
                      }
                    })
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.buildings, function(building) {
                    return _c("marker-building", {
                      directives: [
                        {
                          name: "coords",
                          rawName: "v-coords",
                          value: building,
                          expression: "building"
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.selected || _vm.selected.id !== building.id,
                          expression: "!selected || selected.id !== building.id"
                        }
                      ],
                      key: building.id,
                      attrs: { building: building },
                      nativeOn: {
                        click: function($event) {
                          return _vm.select(building)
                        }
                      }
                    })
                  }),
                  _vm._v(" "),
                  _vm.selected
                    ? _c("marker-details", {
                        directives: [
                          {
                            name: "coords",
                            rawName: "v-coords",
                            value: _vm.selected,
                            expression: "selected"
                          }
                        ],
                        ref: "details",
                        attrs: {
                          id: _vm.selected.id,
                          "max-height": _vm.selectedHeight
                        }
                      })
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("layout-colors"),
              _vm._v(" "),
              _c("layout-zoom"),
              _vm._v(" "),
              _c("ui-loader", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.pending("refresh") ||
                      _vm.pending("heatmap") ||
                      _vm.request,
                    expression:
                      "pending('refresh') || pending('heatmap') || request"
                  }
                ]
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("layout-aside")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }